// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var HTMLNodes$SmartcutsMacros = require("../../../bs-select/src/HTMLNodes.bs.js");
var DOM__Event$SmartcutsMacros = require("../DOM__Event.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var SelectorTree$SmartcutsMacros = require("../../../bs-select/src/SelectorTree.bs.js");
var ViewportPosition$SmartcutsMacros = require("./shared/ViewportPosition.bs.js");
var InnerTextSemantic$SmartcutsMacros = require("../semantics/InnerTextSemantic.bs.js");
var InnerTextSemanticFunctors$SmartcutsMacros = require("../semantics/InnerTextSemanticFunctors.bs.js");
var InnerTextSemanticAuthoringConfig$SmartcutsMacros = require("../semantics/InnerTextSemanticAuthoringConfig.bs.js");
var InnerTextSemanticParamDescriptor$SmartcutsMacros = require("../semantics/InnerTextSemanticParamDescriptor.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "viewportPosition",
                ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
              ],
              [
                "positionRelToElement",
                DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
              ],
              [
                "maybeSubPathToImg",
                Decco.optionToJson((function (param) {
                        return [
                                Selector$SmartcutsMacros.selector_encode(param[0]),
                                Decco.optionToJson(Decco.stringToJson, param[1])
                              ];
                      }), v.maybeSubPathToImg)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
    if (viewportPosition.TAG === /* Ok */0) {
      var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
      if (positionRelToElement.TAG === /* Ok */0) {
        var maybeSubPathToImg = Decco.optionFromJson((function (json) {
                var match = Js_json.classify(json);
                if (typeof match === "number") {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                if (match.TAG !== /* JSONArray */3) {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                var match$1 = match._0;
                if (match$1.length !== 2) {
                  return Decco.error(undefined, "Incorrect cardinality", json);
                }
                var v0 = match$1[0];
                var v1 = match$1[1];
                var match$2 = Selector$SmartcutsMacros.selector_decode(v0);
                var match$3 = Decco.optionFromJson(Decco.stringFromJson, v1);
                if (match$2.TAG === /* Ok */0) {
                  if (match$3.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: [
                              match$2._0,
                              match$3._0
                            ]
                          };
                  }
                  var e = match$3._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = match$2._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[0]" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeSubPathToImg"), null));
        if (maybeSubPathToImg.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    selector: selector._0,
                    viewportPosition: viewportPosition._0,
                    positionRelToElement: positionRelToElement._0,
                    maybeSubPathToImg: maybeSubPathToImg._0
                  }
                };
        }
        var e = maybeSubPathToImg._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".maybeSubPathToImg" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = positionRelToElement._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".positionRelToElement" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = viewportPosition._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".viewportPosition" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function stringify(param) {
  var arg = Belt_Option.map(param.maybeSubPathToImg, (function (param) {
          return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param[0]) + (", imgSrc: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param[1]) + "}")));
        }));
  return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", viewportPosition, positionRelToElement, maybeSubPathToImg: " + ((function (param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                  })("None") + "}")));
}

function deriveMaybeSubPathToImgFromMouseEvent(mouseEvent) {
  var targetElement = mouseEvent.target;
  var tagName = $$String.lowercase_ascii(targetElement.tagName);
  if (tagName === "img") {
    return ;
  } else {
    return Belt_Option.map(Caml_option.nullable_to_opt(document.querySelector("img")), (function (imageElement) {
                  var htmlNodesChainFromImgNodeToTargetElementExclusive = HTMLNodes$SmartcutsMacros.forDomElementAndItsAncestors(Caml_option.some(targetElement), imageElement);
                  var selectorToImgRelativeToTargetElement = SelectorTree$SmartcutsMacros.fromHTMLNodes(htmlNodesChainFromImgNodeToTargetElementExclusive);
                  return [
                          selectorToImgRelativeToTargetElement,
                          Caml_option.nullable_to_opt(imageElement.getAttribute("src"))
                        ];
                }));
  }
}

function fromMouseEvent(mouseEvent) {
  var maybeSubPathToImg = deriveMaybeSubPathToImgFromMouseEvent(mouseEvent);
  var selector = Selector$SmartcutsMacros.forDomEvent(mouseEvent);
  var clientX = mouseEvent.clientX;
  var clientY = mouseEvent.clientY;
  return {
          selector: selector,
          viewportPosition: {
            clientX: clientX | 0,
            clientY: clientY | 0
          },
          positionRelToElement: DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.fromMouseEvent(mouseEvent),
          maybeSubPathToImg: maybeSubPathToImg
        };
}

var Recording = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  fromMouseEvent: fromMouseEvent
};

function getInputIdentifier(param) {
  return Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}

var Authoring = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  fromMouseEvent: fromMouseEvent,
  getInputIdentifier: getInputIdentifier
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "semantic",
                InnerTextSemantic$SmartcutsMacros.t_encode(v.semantic)
              ],
              [
                "viewportPosition",
                ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
              ],
              [
                "positionRelToElement",
                DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var semantic = InnerTextSemantic$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantic"), null));
    if (semantic.TAG === /* Ok */0) {
      var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
      if (viewportPosition.TAG === /* Ok */0) {
        var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
        if (positionRelToElement.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    selector: selector._0,
                    semantic: semantic._0,
                    viewportPosition: viewportPosition._0,
                    positionRelToElement: positionRelToElement._0
                  }
                };
        }
        var e = positionRelToElement._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".positionRelToElement" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = viewportPosition._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".viewportPosition" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = semantic._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".semantic" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function stringify$1(param) {
  return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", viewportPosition, positionRelToElement, semantic=" + (InnerTextSemantic$SmartcutsMacros.stringify(param.semantic) + "}")));
}

function selectorGet(param) {
  return [param.selector];
}

function updateSelector(f, v) {
  return {
          selector: Curry._1(f, v.selector),
          semantic: v.semantic,
          viewportPosition: v.viewportPosition,
          positionRelToElement: v.positionRelToElement
        };
}

var Playback = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1,
  selectorGet: selectorGet,
  updateSelector: updateSelector
};

var CommandValue = {
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

function getSelector(param) {
  return param.selector;
}

var partial_arg = {
  getSelector: getSelector
};

var partial_arg$1 = InnerTextSemanticAuthoringConfig$SmartcutsMacros.MakeTransformers;

function fromAuthoringCommandValueAndSemantic(commandValue, semantic) {
  return {
          selector: commandValue.selector,
          semantic: semantic,
          viewportPosition: commandValue.viewportPosition,
          positionRelToElement: commandValue.positionRelToElement
        };
}

var include = (function (param) {
      return partial_arg$1(partial_arg, param);
    })({
      fromAuthoringCommandValueAndSemantic: fromAuthoringCommandValueAndSemantic
    });

var AuthoringConfig = include;

var partial_arg$2 = InnerTextSemanticParamDescriptor$SmartcutsMacros;

var partial_arg$3 = InnerTextSemanticFunctors$SmartcutsMacros.MakePlaybackParamValue;

var PlaybackParamValue = (function (param) {
      return partial_arg$3(partial_arg$2, param);
    })({
      updateSelector: updateSelector
    });

var ParamDescriptor;

exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* include Not a pure module */
